/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ConstantNodeDependencies } from './dependenciesConstantNode.generated';
import { FunctionNodeDependencies } from './dependenciesFunctionNode.generated';
import { OperatorNodeDependencies } from './dependenciesOperatorNode.generated';
import { ParenthesisNodeDependencies } from './dependenciesParenthesisNode.generated';
import { SymbolNodeDependencies } from './dependenciesSymbolNode.generated';
import { equalDependencies } from './dependenciesEqual.generated';
import { isZeroDependencies } from './dependenciesIsZero.generated';
import { numericDependencies } from './dependenciesNumeric.generated';
import { parseDependencies } from './dependenciesParse.generated';
import { simplifyDependencies } from './dependenciesSimplify.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDerivative } from '../../factoriesAny.js';
export var derivativeDependencies = {
  ConstantNodeDependencies: ConstantNodeDependencies,
  FunctionNodeDependencies: FunctionNodeDependencies,
  OperatorNodeDependencies: OperatorNodeDependencies,
  ParenthesisNodeDependencies: ParenthesisNodeDependencies,
  SymbolNodeDependencies: SymbolNodeDependencies,
  equalDependencies: equalDependencies,
  isZeroDependencies: isZeroDependencies,
  numericDependencies: numericDependencies,
  parseDependencies: parseDependencies,
  simplifyDependencies: simplifyDependencies,
  typedDependencies: typedDependencies,
  createDerivative: createDerivative
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDerivative.generated.js
// module id = 1388
// module chunks = 0